angular
  .module 'gym.components'
  .directive 'userMfa', () ->
    restrict: 'E'
    template: require('templates/components/profile/userMfa.html.slim')
    scope: { setTab: '=' }
    controller: (
      $scope,
      $rootScope,
      ReactModal,
      MasqueradingService,
      $window,
      $http,
      flash
    ) ->
      $scope.gym = $rootScope.gym
      $scope.isAccountOwner = window.currentUser.account_owner

      $scope.setProfileTab = () ->
        $scope.setTab('profile')

      $scope.isMasquerading = MasqueradingService.isMasquerading()

      $scope.user = window.currentUser

      $scope.isEnableBlocked = ->
        !$scope.data || $scope.isLoading

      updateIsDisableBlocked = ->
        $scope.isDisableBlocked = !$scope.data || $scope.isLoading || ($scope.data.multi_factor_auth_required_default && !$scope.isAccountOwner)

      updateIsEnableBlocked = ->
        $scope.isEnableBlocked = !$scope.data || $scope.isLoading

      $scope.$watch 'data', ->
        updateIsDisableBlocked()
        updateIsEnableBlocked()
        
      $scope.$watch 'isAccountOwner', -> updateIsDisableBlocked()

      $scope.confirmUser = () ->
        ReactModal.open(
          component: 'ManageMfaModal'
          props:
            mode: 'confirm_password'
        )

      $scope.enableMfa = () ->
        if ($scope.user.ssi_enabled && !$scope.isMasquerading)
          $scope.enable()
        else if (!$scope.user.ssi_enabled && !$scope.isMasquerading)
          ReactModal.open(
            component: 'ManageMfaModal'
            props:
              mfaAction: 'enable',
              mode: 'confirm_password'
          )

      $scope.loadStatus = () ->
        url = "/gyms/#{$scope.gym.id}/profile/multi_factor_auth_status"
        $http.get(url).then (response) ->
          $scope.data = response.data

      $scope.loadStatus()

      $scope.enable = ->
        url = "/users/enable_twilio_verify"
        $http.post(url).then () ->
          $window.location.reload()
        , () ->
          flash.error = "An error occurred while enabling multi-factor authentication for your account."
